import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Select } from '@outdoor-voices/ui';
import { memo, useEffect, useState } from 'react';
import { XLarge } from '@outdoor-voices/ui';
import * as Sentry from '@sentry/browser';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { DT } from '../../config/constants';
import { OV_SUBSCRIBE_URL } from '../../config/theme';
import cacheSubscribed from '../../utils/subscription/cache';
import CheckBox from '../../components/CheckBox';
import overlayCSS from '../../components/Ovly/index.module.scss';
import css from './WaitlistForm.module.scss';
import Overlay from '../../components/Overlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MEN = 'MEN';
var NONE = 'NONE';
var WOMEN = 'WOMEN';
var BOTH = 'BOTH';

var WaitlistForm = function WaitlistForm(_ref) {
  var comingSoon = _ref.comingSoon,
      displayTitle = _ref.displayTitle,
      initialGender = _ref.gender,
      hideWaitlist = _ref.hideWaitlist,
      on = _ref.on,
      variant = _ref.variant;
  var CUSTOMER = window.OV.CUSTOMER;
  var validInitialGender = initialGender === WOMEN || initialGender === MEN;

  var _useState = useState({
    email: (CUSTOMER.loggedIn ? CUSTOMER.email : '') || '',
    gender: validInitialGender ? initialGender : NONE,
    subscribe: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitting = _useState4[0],
      setSubmitting = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitted = _useState6[0],
      setSubmitted = _useState6[1];

  var email = state.email,
      gender = state.gender,
      subscribe = state.subscribe;
  var shopForProps = subscribe ? {
    required: true
  } : {};

  var onSubmitError = function onSubmitError(exception) {
    console.error(exception);

    if (Sentry) {
      Sentry.captureException(exception, {
        extra: {
          context: 'Waitlist.subscribe'
        }
      });
    }
  };

  var onCheckboxChange = function onCheckboxChange(event) {
    var value = event.target.value;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      subscribe: !value
    }));
  };

  var onInputChange = function onInputChange(event) {
    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;

    if (event && event.stopPropagation) {
      event.stopPropagation();
    }

    setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, value)));
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var email, gender, body, request, _body, _request;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = state.email, gender = state.gender;
              body = {
                email: email,
                variant: variant
              };
              event.preventDefault();
              setSubmitting(true);
              _context.prev = 4;
              _context.next = 7;
              return fetch("".concat(OV_SUBSCRIBE_URL, "waitlist/"), {
                body: JSON.stringify(body),
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 7:
              request = _context.sent;
              _context.next = 10;
              return request.json();

            case 10:
              if (!subscribe) {
                _context.next = 18;
                break;
              }

              _body = {
                email: email,
                gender: gender,
                source: 'Waitlist'
              };
              _context.next = 14;
              return fetch(OV_SUBSCRIBE_URL, {
                body: JSON.stringify(_body),
                headers: {
                  'Content-Type': 'application/json'
                },
                method: 'POST'
              });

            case 14:
              _request = _context.sent;
              _context.next = 17;
              return _request.json();

            case 17:
              cacheSubscribed();

            case 18:
              setSubmitting(false);
              setSubmitted(true);
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](4);
              onSubmitError(_context.t0);
              setSubmitting(false);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 22]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (!submitted || !hideWaitlist) {
      return;
    }

    var hide = function hide() {
      hideWaitlist();
    };

    var interval = setTimeout(hide, 5000);
    return function () {
      clearInterval(interval);
    };
  }, [submitted, hideWaitlist]);
  return /*#__PURE__*/_jsx(Overlay, {
    ariaLabelledBy: "waitlist-title",
    ariaDescribedBy: "wait-list-description",
    onHide: function onHide() {
      return hideWaitlist();
    },
    on: on,
    children: /*#__PURE__*/_jsxs("div", {
      className: cc([overlayCSS.root, css.root, _defineProperty({}, overlayCSS.on, on)]),
      children: [!submitted && /*#__PURE__*/_jsxs("form", {
        onSubmit: onSubmit,
        children: [displayTitle && /*#__PURE__*/_jsx("h3", {
          className: css.title,
          id: "waitlist-title",
          children: displayTitle
        }), /*#__PURE__*/_jsxs("p", {
          className: css.copy,
          id: "wait-list-description",
          children: ["We'll send you a note when this item is ", comingSoon ? 'available.' : 'back in stock.']
        }), /*#__PURE__*/_jsx("div", {
          className: css.field,
          children: /*#__PURE__*/_jsxs("label", {
            className: css.label,
            htmlFor: "email",
            children: [/*#__PURE__*/_jsx("span", {
              className: "ada-hidden",
              children: "Enter your email"
            }), /*#__PURE__*/_jsx("input", {
              className: css.input,
              id: "email",
              name: "email",
              onChange: onInputChange,
              placeholder: "Enter your email",
              required: true,
              type: "email",
              value: email
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: css.field,
          children: [/*#__PURE__*/_jsx(CheckBox, {
            centered: true,
            checked: subscribe,
            id: "newsletter-signup",
            label: "Sign Up for OV News and Updates",
            name: "subscribe",
            onChange: onCheckboxChange,
            value: subscribe
          }), /*#__PURE__*/_jsx("div", {
            className: css.selectWrap,
            children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, shopForProps), {}, {
              buttonProps: {
                full: true,
                gray: true
              },
              label: "Gender Select",
              hideLabel: true,
              id: "newsletter-gender",
              name: "gender",
              onChange: onInputChange,
              options: [{
                label: "I'm shopping for...",
                value: NONE
              }, {
                label: "Women's Apparel",
                value: WOMEN
              }, {
                label: "Men's Apparel",
                value: MEN
              }, {
                label: 'Both',
                value: BOTH
              }],
              value: gender
            }))
          })]
        }), /*#__PURE__*/_jsx(Button, {
          ariaLabel: "Submit and join the waitlist",
          big: true,
          disabled: submitting,
          type: "submit",
          children: submitting ? DT : 'Submit'
        })]
      }), submitted && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("h3", {
          className: css.title,
          children: "Thanks!"
        }), /*#__PURE__*/_jsx("p", {
          className: css.copy,
          children: "You'll get an email once it\u2019s available."
        })]
      }), /*#__PURE__*/_jsx("button", {
        "aria-label": "Close the waitlist dialog",
        className: overlayCSS.close,
        onClick: function onClick() {
          return hideWaitlist();
        },
        type: "button",
        children: /*#__PURE__*/_jsx(XLarge, {})
      })]
    })
  });
};

WaitlistForm.propTypes = {
  comingSoon: PropTypes.bool,
  displayTitle: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  hideWaitlist: PropTypes.func.isRequired,
  on: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default /*#__PURE__*/memo(WaitlistForm);